import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserUniformDesignGame from 'src/games/UniformDesignGame/main';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(XraySliderGame)'
interface UniformDesignGameProps extends RouteComponentProps<{}> {
    onComplete?: () => void;
}

interface UniformDesignGameState {
}

class UniformDesignGame extends React.Component<UniformDesignGameProps, UniformDesignGameState> {
    constructor(props: UniformDesignGameProps) {
        super(props);
        bindAllOfThis(this, UniformDesignGame.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserUniformDesignGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default UniformDesignGame;



// WEBPACK FOOTER //
// ./src/pages/game/UniformDesignGame.tsx